class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    // this.notification.classList.add('animate', 'active');

    // this.notification.addEventListener('transitionend', () => {
    //   this.notification.focus();
    //   trapFocus(this.notification);
    // }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
		jumpToShoppingCart()
	
  }

  close() {
    // this.notification.classList.remove('active');

    // document.body.removeEventListener('click', this.onBodyClick);

    // removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
    
      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    if($('#cart-notification-product').html().indexOf('UploadDesign 1')>=0){
      $('#cart-notification-product>div>img').attr('src',$('#cart-notification-product .link').attr('href'))
    }
    $('#cart-notification-product .product-option').map(res=>{
        var str=$($('#cart-notification-product .product-option')[res]).text()
        if(str.indexOf('quantityvalue: ')>=0||str.indexOf('saleNum: ')>=0){
          $($('#cart-notification-product .product-option')[res]).hide()
        }
        if(str.indexOf('quantityvalue: ')>=0||str.indexOf('notequte: ')>=0){
          $($('#cart-notification-product .product-option')[res]).hide()
        }
      if(str.indexOf('quantityvalue: ')>=0||str.indexOf('Shape: ')>=0){
          $($('#cart-notification-product .product-option')[res]).hide()
        }
      if(str.indexOf('quantityvalue: ')>=0||str.indexOf('customquantity: ')>=0){
          $($('#cart-notification-product .product-option')[res]).hide()
        }
      if(str.indexOf('notequtez: ')>=0){
          $($('#cart-notification-product .product-option')[res]).hide()
        }
      if(str.indexOf('zlgid: ')>=0){
          $($('#cart-notification-product .product-option')[res]).hide()
        }
      if(str.indexOf('material: ')>=0){
          $($('#cart-notification-product .product-option')[res]).hide()
        }
      if(str.indexOf('Size: ')>=0){
          $($('#cart-notification-product .product-option')[res]).hide()
        }
        if(str.indexOf('Total Price: ')>=0){
          $($('#cart-notification-product .product-option')[res]).hide()
        }
      })
    if(html.indexOf('<div id="shopify-section-cart-notification-product"')>=0){
      $('.shopify-section-cart-notification-productzzzzz').html(html)
    }
    if(html.indexOf('<div id="shopify-section-cart-notification-button" class="shopify-section">')>=0){
      html='<div id="shopify-section-cart-notification-button" class="shopify-section">'+'View my cart ('+$(".shopify-section-cart-notification-productzzzzz>div").children().length+')</div>'
    }
    $('#cart-notification-form button').text('Checkout')
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
